function initialize() {
  const swiper = new Swiper(".swiper", {
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      formatFractionCurrent: function (number) {
        return number;
      },
      formatFractionTotal: function (number) {
        return number;
      },
      renderFraction: function (currentClass, totalClass) {
        return (
          '<span class="' +
          currentClass +
          '"></span>' +
          " of " +
          '<span class="' +
          totalClass +
          '"></span>'
        );
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
initialize();

document.addEventListener("shopify:section:load", initialize);


var swiperBtnZoom = document.getElementById("swiper-wrapper__btn-zoom");
var productZoom = document.getElementById("product-zoom");

swiperBtnZoom.onclick = function () {
  productZoom.classList.toggle("is-loading");
};

const accordionList = document.querySelectorAll(".accordion__item");

accordionList.forEach((event) =>
  event.addEventListener("click", () => {
    if (event.classList.contains("active")) {
      event.classList.remove("active");
    } else {
      accordionList.forEach((event) => event.classList.remove("active"));
      event.classList.add("active");
    }
  })
);


function openTab(evt, linkName) {
  var i, productTabContent, productTabLinks;
  productTabContent = document.getElementsByClassName("product-tab__content");
  for (i = 0; i < productTabContent.length; i++) {
    productTabContent[i].style.display = "none";
  }
  productTabLinks = document.getElementsByClassName("product-tab__links");
  for (i = 0; i < productTabLinks.length; i++) {
    productTabLinks[i].className = productTabLinks[i].className.replace(
      " active",
      ""
    );
  }
  document.getElementById(linkName).style.display = "block";
  evt.currentTarget.className += " active";
}
